import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import { APCardColor } from "../../components/cards/APCard";
import { AutoCompleteOption } from "../../components/form/APAutoComplete";
import { accountTextColorMap } from "../viewDossiers";

const DossierFilterSummary = ({
  accounts,
  dossierStatuses,
  employeeSearch,
  accountColorMap,
  hideAccounts = false,
}: {
  accounts: AutoCompleteOption[];
  dossierStatuses: AutoCompleteOption[];
  employeeSearch: string;
  accountColorMap: Record<string, APCardColor>;
  hideAccounts?: boolean;
}) => {
  const fieldTexts = [];

  if (accounts.length > 0 && !hideAccounts) {
    const accountTexts = [];

    accountTexts.push(
      <Typography variant="titleSmall" key="accounts" component="span">
        Employers ={" "}
      </Typography>
    );

    accounts.forEach((account, index) => {
      const accountColor = accountColorMap[account.id];
      const accountTextColor = accountColor
        ? accountTextColorMap[accountColor]
        : undefined;

      accountTexts.push(
        <Typography
          variant="titleSmall"
          key={account.id}
          sx={{ color: accountTextColor }}
          component="span"
        >
          {account.label}
        </Typography>
      );
      if (index < accounts.length - 1) {
        accountTexts.push(
          <Typography
            variant="titleSmall"
            key={`account-separator-${index}`}
            fontWeight={700}
            component="span"
          >
            {", "}
          </Typography>
        );
      }
    });

    fieldTexts.push(<>{accountTexts}</>);
  }

  if (dossierStatuses.length > 0) {
    fieldTexts.push(
      <Typography variant="titleSmall" key="statuses" component="span">
        {`Status = ${dossierStatuses.map((status) => status.label).join(", ")}`}
      </Typography>
    );
  }
  if (employeeSearch) {
    fieldTexts.push(
      <Typography variant="titleSmall" key="employeeSearch" component="span">
        {`Search = ${employeeSearch}`}
      </Typography>
    );
  }

  return (
    <Box mb={2}>
      {fieldTexts.map((text, index) => (
        <Box component="span" key={index}>
          {text}
          {index < fieldTexts.length - 1 && (
            <Typography variant="titleSmall" fontWeight={700} component="span">
              {" "}
              AND{" "}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default DossierFilterSummary;
